import { defineMessages } from 'react-intl';

export default defineMessages({
    rvVehicleTitle: {
        id: 'quoteandbind.rv.views.rv-vehicle-details.Vehicle',
        defaultMessage: 'Vehicle',
    },
    rvVehicleTitleNumber: {
        id: 'quoteandbind.rv.views.rv-vehicle-details.Vehicle:',
        defaultMessage: 'Vehicle:',
    },
    rvAddAnotherVehicleTitle: {
        id: 'quoteandbind.rv.views.rv-driver-details.Add Another Vehicle?',
        defaultMessage: 'Add Another Vehicle?',
    },
    rvAddDriverButtonText: {
        id: 'quoteandbind.rv.views.rv-driver-details.Add Vehicle',
        defaultMessage: 'Add Vehicle',
    },
    removeVehicleTitle: {
        id: 'quoteandbind.rv.controllers.rvVehicleDetailsCtrl.Remove Vehicle?',
        defaultMessage: 'Remove Vehicle?',
    },
    removeVehicleDescription: {
        id: 'quoteandbind.rv.drivers.remove-vehicle.message',
        defaultMessage: 'Are you sure you want to remove this vehicle from the list of vehicles?',
    },
    fillInMsg: {
        id: 'quoteandbind.rv.directives.templates.rv-edit-vehicle.fillInMsg',
        defaultMessage: 'After you enter a VIN and move to the next field, the Make, Model and Year fields will be filled in automatically if possible.',
    },
    additionalInterestsForThisVehicle: {
        id: 'quoteandbind.rv.views.rv-vehicle-details.Additional Interests for This Vehicle',
        defaultMessage: 'Additional Interests for This Vehicle',
    },
    rvAddAdditionalInterestType: {
        id: 'quoteandbind.views.rv-your-home.additional-interest.Type',
        defaultMessage: 'Type',
    },
    rvAddAdditionalInterestFirstName: {
        id: 'quoteandbind.views.rv-your-home.additional-interest.First Name',
        defaultMessage: 'First Name',
    },
    rvAddAdditionalInterestLastName: {
        id: 'quoteandbind.views.rv-your-home.additional-interest.Last Name',
        defaultMessage: 'Last Name',
    },
    rvAddAdditionalInterestLastName: {
        id: 'quoteandbind.views.rv-your-home.additional-interest.Middle Name',
        defaultMessage: 'Middle Name',
    },
    rvAddAdditionalInterestCountry: {
        id: 'quoteandbind.views.rv-your-home.additional-interest.Country',
        defaultMessage: 'Country',
    },
    rvAddAdditionalInterestAddress: {
        id: 'quoteandbind.views.rv-your-home.additional-interest.Address',
        defaultMessage: 'Address',
    },
    rvAddAdditionalInterestCity: {
        id: 'quoteandbind.views.rv-your-home.additional-interest.City',
        defaultMessage: 'City',
    },
    rvAddAdditionalInterestState: {
        id: 'quoteandbind.views.rv-your-home.additional-interest.State',
        defaultMessage: 'State',
    },
    rvAddAdditionalInterestZipCode: {
        id: 'quoteandbind.views.rv-your-home.additional-interest.ZIP Code',
        defaultMessage: 'ZIP code',
    },
    rvAddAdditionalInterestInterestType: {
        id: 'quoteandbind.views.rv-your-home.additional-interest.Interest Type',
        defaultMessage: 'Interest Type',
    },
    rvAddAdditionalInterestAddressType: {
        id: 'quoteandbind.views.rv-your-home.additional-interest.Address Type',
        defaultMessage: 'Address Type',
    },
    rvAddAdditionalInterestPhoneNumber: {
        id: 'quoteandbind.views.rv-your-home.additional-interest.Phone Number',
        defaultMessage: 'Phone Number',
    },
    rvAddAdditionalInterestEmail: {
        id: 'quoteandbind.views.rv-your-home.additional-interest.Email',
        defaultMessage: 'Email',
    },
    rvAddAdditionalInterestForThisVehicle: {
        id: 'quoteandbind.rv.views.rv-driver-details.Additional Interests for This Vehicle',
        defaultMessage: 'Additional Interests for This Vehicle',
    },
    additionalInterestCount: {
        id: 'quoteandbind.views.rv-vehicles.additional-interest.Additional Interest:',
        defaultMessage: 'Additional Interest: { count }'
    },
    rvAddAdditionalInterest: {
        id: 'quoteandbind.rv.views.rv-driver-details.Additional Interests',
        defaultMessage: 'Additional Interests',
    },
});
